import { useEffect } from 'react'
import { NumberParam, useQueryParams } from 'use-query-params'

export const useSavedScrollPosition = ({
  dependencies,
  condition,
  setScroll,
}: {
  dependencies: unknown[]
  condition: boolean
  setScroll?: (data: { top: number; left: number }) => void
}) => {
  const [query, setQuery] = useQueryParams({
    scrollX: NumberParam,
    scrollY: NumberParam,
  })

  const saveScroll = (data?: { scrollX?: number; scrollY?: number }) => {
    const { scrollX, scrollY } = data ?? {}
    setQuery({ scrollX: scrollX ?? window.scrollX, scrollY: scrollY ?? window.scrollY }, 'pushIn')
  }

  const defaultSetScroll = ({ top, left }: { top: number; left: number }) => {
    window.scrollTo({
      top,
      left,
      behavior: 'smooth',
    })

    // We need to use setTimeout in this case due to Safari-only issue.
    // `window.scrollTo` works great in all other browsers, but not in Safari.
    // So that is why we are wrapping `window.scroll` into setTimeout here.
    setTimeout(() => {
      window.scroll({ top, left, behavior: 'smooth' })
    }, 10)
    setQuery({ scrollY: undefined, scrollX: undefined })
  }

  useEffect(() => {
    const top = query?.scrollY ?? 0
    const left = query?.scrollX ?? 0
    if (condition) {
      const scrollFunction = setScroll ?? defaultSetScroll
      scrollFunction({ top, left })
    }
  }, dependencies)

  return { saveScroll }
}
